import withReducer from '../../store/withReducer'
import ReportFile from './container'
import reducer from './module'

export default withReducer('reportFile', reducer)(ReportFile)



// WEBPACK FOOTER //
// ./src/legacy/containers/ReportFile/index.js